<template>
    <sa-page-layout :btnBackVisible="false" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnRefreshVisible="false" @refresh="onRefresh">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Cognome:</label>
                        <b-form-input v-model="filtro.cognome" type="search" id="cognome" placeholder="Cognome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Nome:</label>
                        <b-form-input v-model="filtro.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Identificativo:</label>
                        <b-form-input v-model="filtro.identificativo" type="search" id="identificativo" :placeholder="this.$i18n.t('adi.lblFiscalCode')"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Piano:</label>
                        <b-form-select v-model="filtro.idPiano" :options="pianiOptions" :value="null" value-field="id" text-field="nome"></b-form-select>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-gestione-ospiti-parametri-vitali-list-component ref="cmpRsaPazienteParametriVitaliList"></rsa-gestione-ospiti-parametri-vitali-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
// import DatePicker from "vue2-datepicker";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaGestioneOspitiParametriVitaliListComponent from "../components/RsaGestioneOspitiParametriVitaliListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,

        // DatePicker,
        RsaGestioneOspitiParametriVitaliListComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            pathResourcePiani: "/rsapostilettopiani",
            linkedit: null,
            idPresidio: null,
            pianiOptions: [],
            filtro: { nome: null, cognome: null, identificativo: null, idPiano: null },
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            presidio: {},
            listKey: 0,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.loadDataPiani();
        me.filtro.idPaziente = me.idAccettazione;
        me.filtro.dataAl = new Date().getTime() + 24 * 60 * 60 * 1000;
        me.filtro.dataDal = me.filtro.dataAl - 30 * 24 * 60 * 60 * 1000;
        if (localStorage.getItem("presidio")) {
            me.presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
            me.idPresidio = me.presidio ? me.presidio.idPresidio : null;
            me.filtro.idPresidio = me.idPresidio;
        }
        me.$refs.cmpRsaPazienteParametriVitaliList.loadData(me.filtro);
    },
    methods: {
        onRefresh() {
            let me = this;
            me.$refs.cmpRsaPazienteParametriVitaliList.loadData(me.filtro);
        },
        onReset() {
            let me = this;
            me.filtro = { nome: null, cognome: null, identificativo: null, idPiano: null };
            me.filtro.idPresidio = me.idPresidio;
            me.filtro.dataAl = new Date().getTime();
            me.filtro.dataDal = me.filtro.dataAl - 30 * 24 * 60 * 60 * 1000;
            me.$refs.cmpRsaPazienteParametriVitaliList.loadData(me.filtro);
        },
        onSubmit() {
            let me = this;
            me.$refs.cmpRsaPazienteParametriVitaliList.loadData(me.filtro);
        },
        notBeforeDataDal(date) {
            let me = this;
            return date < me.filtro.dataDal;
        },
        loadDataPiani() {
            let me = this;
            let filtroPiano = {};
            if (me.idPresidio) {
                filtroPiano.idPresidio = me.idPresidio;
            }
            UtilityMixin.methods.loadDataResources(me.pathResourcePiani, filtroPiano, me.loadDataPianiSuccess, me.loadDataPianiError);
        },
        loadDataPianiSuccess(response) {
            let me = this;

            me.pianiOptions = response.data.data.list;
            me.pianiOptions.unshift({ id: null, nome: "- Selezionare Piano -" });
        },
        loadDataPianiError(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            me.$bvToast.toast("Errore durante il caricamento dei piani", messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>

<style></style>
